import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowsAltH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 7"
    {...props}
  >
    <path
      fill="#454655"
      d="M13.565 3.589a.29.29 0 0 1 0 .431L11.05 6.534c-.203.203-.533.05-.533-.203V4.503H3.79V6.33c0 .254-.33.406-.534.203L.743 4.02a.29.29 0 0 1 0-.431l2.513-2.514c.203-.203.534-.051.534.203V3.08h6.728V1.278c0-.254.33-.406.533-.203z"
    />
  </svg>
);
export default SvgArrowsAltH;
